module.exports = new __parcel__URL__("Project Plan.f28f7914.svg").toString();